export enum Color {
  TRANSPARENT = 'transparent',
  PRIMARY_LIGHT = '#FFFFFF',
  PRIMARY_LIGHT_GRAY = '#EEEDE9',
  DARK_GRAY = '#67686A',
  TEXT_COLOR_LINK_BUTTON = '#2246FC',
  EERIE_BLACK = '#1D1C1D',
  INPUT_ERROR = '#a2191c'
}

export type CardColors = 'card' | 'plan' | 'aus-summary' | 'details';

export type ComponentColors =
  | 'default'
  | 'ghost'
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'gradient'
  | 'link-transparent'
  | CardColors;

export type ChipColors = ComponentColors | 'high' | 'low' | 'medium' | 'negative' | 'positive';
